<template>
  <div class="workerorderindex">
    <top></top>
    <div class="nav">
      <router-link style="color:rgb(31, 55, 61);"  :to="urlb" >
          <span @click="hisback">首页</span>
      </router-link>
      <!-- <router-link style="color:rgb(31, 55, 61);" :to="{ path: '/workerorderindex'}">
          <span>首页</span>
      </router-link> -->
      <span class="navbread" v-for="(item, index) in questionclass " :key="index">{{'>'+item}}</span>
      <a class="btna color" href="#/myorder" :style="{backgroundColor:boxBodyColor}">我的工单</a>
    </div>
    <div class="content" v-show="contentis" v-for="(item,index1) in showdata" :key="index1">
       <div v-if="item.typeId==12">
          <span class="label">{{item.name+':'}}</span>
          <el-select class="wid" v-model="gamevalue[item.id]"  @visible-change="changedata(item)"  @change="datacommit(gamevalue[item.id],item)">
          <el-option
            v-for="item in gamearea[item.id]"
            :key="item.label"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
       </div>
      <div class="dns" v-else-if="item.typeId==1">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="dns[item.id]" :placeholder="item.defaultContent"   @blur="datacommit(dns[item.id],item)"></el-input>
       </div>
        <div class="dns" v-else-if="item.typeId==5">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="phonenumver[item.id]" :placeholder="item.defaultContent" @blur="datacommit(phonenumver[item.id],item)"></el-input>
       </div>
       <div class="dns" v-else-if="item.typeId==6">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="number[item.id]" :placeholder="item.defaultContent" @blur="datacommit(number[item.id],item)"></el-input>
       </div>
       <div class="dns" v-else-if="item.typeId==7">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="idcard[item.id]" :placeholder="item.defaultContent" @blur="datacommit(idcard[item.id],item)"></el-input>
       </div>
       <div class="dns" v-else-if="item.typeId==8">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="email[item.id]" :placeholder="item.defaultContent" @blur="datacommit(email[item.id],item)"></el-input>
       </div>
         <div class="explain" v-else-if="item.typeId==2">
          <span class="label">{{item.name+':'}}</span>
         <el-input
            class="wid"
            type="textarea"
            :rows="4"
            v-model="explain[item.id]"
            :placeholder="item.defaultContent"
            @blur="datacommit(explain[item.id],item)">
          </el-input>
       </div>
      <div class="sex" v-else-if="item.typeId==13">
         <span class="label">{{item.name+':'}}</span>
         <el-radio-group class="radio" v-model="sex[item.id]" @change="datacommit(sex[item.id],item)">
           <el-radio v-for="(ele,index2) in sexlabel[item.id]"   :label="ele.value" :key="index2">{{ele.value}}</el-radio>
        </el-radio-group>
       </div>
        <!--<div class="hobbys">
         <span class="label">兴趣爱好:</span>
         <span :class=" {'hobby':true, 'back':item.is}" v-for="(item,index) in hobbys" @click="heightlight(index)" > {{item.value}}</span>
         <p>多选，您可以选择1-5个选项</p>
       </div>-->
       <div class="picture" v-else-if="item.typeId==9">
         <span class="label">{{item.name+':'}}</span>
         <p class="pictureclass" style="width:300px;float: left;">为了帮助您更好的解决问题,请上传相关描述的图片。每张不超过9M，支持jpg、png、bmp、gif</p>
           <el-upload
            class="upload-demo wid"
            :action="action"
            :on-success="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeload"
            :file-list="fileList2[item.name]"
            list-type="picture"
            :withCredentials=true>
            <el-button @click="datacommit(fileList2[item.name],item)" :id="item.spanid+'a'"  v-if="picid[item.id]==true"  size="small" type="primary" class="color" style="margin-top:10px" :style="{backgroundColor:boxBodyColor}"> 添加文件 </el-button>
          </el-upload>
       </div>
       <div class="city" v-else-if="item.typeId==14">
          <span class="label">{{ item.name+':' }}</span>
           <el-checkbox-group
            v-model="checkedCities1[item.id]"
            :min="1"
            class="cityclass"
            @change="datacommit(checkedCities1[item.id],item)"
            >
            <el-checkbox v-for="city in cities[item.id]" :label="city" :key="city">{{city}}</el-checkbox>
          </el-checkbox-group>
       </div>
       <div class="date" v-else-if="item.typeId==3">
          <span class="label">{{item.name+':'}}</span>
          <div class="block">
            <el-date-picker
              v-model="datetime[item.id]"
              type="date"
              :placeholder="item.defaultContent"
              :picker-options="pickerOptions0"
              class="time"
              @change="datacommit(datetime[item.id],item)">
            </el-date-picker>
          </div>
       </div>
       <div class="date" v-else-if="item.typeId==4">
          <span class="label">{{item.name+':'}}</span>
          <div class="block">
            <el-time-picker
              v-model="hourtime[item.id]"
              type="date"
              :placeholder="item.defaultContent"
              class="time"
              @change="datacommit(hourtime[item.id],item)">
            </el-time-picker>
          </div>
       </div>
       <div class="picture" v-else-if="item.typeId==15">
         <span class="label">{{item.name+':'}}</span>
         <p class="pictureclass" style="width:300px;float: left;">为了帮助您更好的解决问题,请上传相关描述的视频。视频大小不超过500M</p>
           <el-upload
            class="upload-demo wid"
            :action="action"
            :on-success="handleVideoPreview"
            :on-remove="handleVideoRemove"
            :before-upload="videoBeforeload"
            :file-list="fileVideoList[item.id]"
            list-type="picture"
            accept="video/*"
            :withCredentials=true>
            <el-button @click="datacommit(fileVideoList[item.id],item)" :id="item.spanid+'a'" v-if="picid[item.id]==true"  size="small" type="primary" class="color" style="margin-top:10px" :style="{backgroundColor:boxBodyColor}"> 添加文件 </el-button>
          </el-upload>
       </div>
        <div class="date" v-else-if="item.typeId==16">
          <span class="label">{{item.name+':'}}</span>
          <div class="block">
            <el-date-picker
              v-model="datetimes[item.id]"
              type="datetime"
              class="time"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="item.defaultContent || '选择日期时间'"
              @change="datacommit(datetimes[item.id], item)">
            </el-date-picker>
          </div>
       </div>
      <span class="error1" v-if="(item.required==true && (item.typeId ==12 || item.typeId ==13 || item.typeId ==14) && (item.enteredValue == '' || item.enteredValue == null)) || (item.required==true && !(item.typeId ==12 || item.typeId ==13 || item.typeId ==14) && (item.enteredValue == '' || item.enteredValue == null))" :id="item.spanid">*必填项</span>
      <span class="error1" v-else :id="item.spanid"></span>
       <p style="clear:both"></p>
    </div>
    <div class="btn" v-if="contentis==true && btnclass==1">
      <el-button class="color" type="primary" @click="commit" :style="{backgroundColor:boxBodyColor}">提交</el-button>
    </div>
     <div class="btn" v-else-if="contentis==true && btnclass==2">
       <el-button class="color" type="primary" style="background:#ccc">提交</el-button>
    </div>
    <div class="download" v-show="downloadis">
      <img src="../../assets/workorder/download.png">
      <p>正在提交...</p>
    </div>
    <div class="success" v-show="successis">
      <img src="../../assets/workorder/success.png">
      <h4>提交成功,感谢您的反馈！</h4>
      <p>{{jishi+'秒之后返回首页'}}</p>
    </div>
    <div class="success" v-show="erroris">
      <img src="../../assets/workorder/error.png">
      <h4 class="error">问题反馈失败,请稍后再试！</h4>
      <p>{{jishi+'秒之后返回首页'}}</p>
    </div>
    <div class="login" v-show="loginis">
        <p>手机号为查看单据处理结果的依据</p>
        <div>
          <span>手机号</span>
          <el-input v-model="phone" class="phonenumber" placeholder="请输入手机号码" @blur="phonego"></el-input>
          <p >{{phoneis}}</p>
        </div>
        <div class="mat">
          <span>随机码</span>
          <el-input v-model="verify" class="verify" placeholder="短信随机码"></el-input>
          <span v-if="verifyis" class="verifybtn" @click="verifygo" :style="{backgroundColor:boxBodyColor}">获取随机码</span>
          <span v-else class="verifybtn" :style="{backgroundColor:boxBodyColor}">{{timesecond+"s"}}</span>.
           <p>{{veris}}</p>
        </div>
        <el-button class="color verbtn" type="primary" @click="verifyconfirm" :style="{backgroundColor:boxBodyColor}">下一步</el-button>
    </div>

  </div>

</template>

<script>
import * as Urls from '../url.js'
import top from '../workorder/top.vue'
import axios from '@/utils/request.js'
import { parseTime } from '@/utils/index.js'
export default {
  name: 'commitinfor',
  components: {
    top
  },
  data () {
    return {
      paixu:[],
      boxBodyColor:'',
      logoUrl:'',
      companyName:'',
      displayMode:'',
      btnclass:2,
      btnis:false,
      urlb:'',
      urlbridge:"",
      datetimes:{},
      jishi:5,
      kefuis:false,
      action:'',
      phone:"",
      phoneis:"",
      veris:'',
      verify:"",
      verifyis:true,
      timesecond:60,
      basurl:Urls.baseurl,
      md5:"",
      href:"",
      showdata:[],
      erroris:false,
      successis:false,
      downloadis:false,
      loginis:false,
      contentis:true,
      pickerOptions0: {
          // disabledDate(time) {
          //   return time.getTime() < Date.now() - 8.64e7;
          // }
      },
      commitis:false,
      datetime:{},
      hourtime:{},
      phonenumver:{},
      number:{},
      idcard:{},
      email:{},
      fileList2:{},
      allquestion:[],
      questionclass:[],
      gamearea:{},
      gamevalue:{},
      fileVideoList:{},
      dns:{},
      explain:{},
      sex:{},
      sexlabel:{},
      hobbys:[{value:"运动",is:false},{value:"宅",is:false},{value:"电影",is:false},{value:"美食",is:false},{value:"DIY",is:false}],
      checkedCities1: {"id":['上海']},
      cities:{},
      parmas:[],
      submittable:{},
      picid:{}
    }
  },
  mounted(){
    var vm =this;
    this.questionclass=[];
    this.questionclass.push(sessionStorage.getItem("butianitem"));
    this.questionclass.push("单据提交");
    this.md5=sessionStorage.getItem("md5");
    this.href= window.location.href.split("?")[1];
    this.butianinfor()
      vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')
      //console.log(vm.companyName)
      vm.logoUrl = sessionStorage.getItem('logoUrl');
      vm.displayMode = sessionStorage.getItem('displayMode')

    //判断客服是否显示
     axios.get(this.basurl+'/api/visitor/product/conf/showOnlineService?visitorMd5Code='+this.md5).then(function(response){
        if(response.data.code==1){
          vm.kefuis=true;
        }
     })
  },
  methods:{
     //判断跳转页面
    kefugo(){
        axios.get(this.basurl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+this.md5).then(function(response){

          if(response.data.code==1){
            var obj=response.data.data;

            if(obj.imStatus==" waiting"){

              window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){

               window.location.href="#/imSession";
            }else{
                if(obj.target==1){
                  window.location.href="#/spirit";
                }
                if(obj.target==2){
                  window.location.href="#/imDirectory";
                }
            }
          }
        })
    },
    hisback(){
      var vm=this;
      var indexurl=sessionStorage.getItem("indexUrl");
      console.log(indexurl)
      var imEntranceMode=sessionStorage.getItem("imEntranceMode");
      console.log(imEntranceMode)
      if (indexurl == 'aiInteractive') {
        window.location.href = "#/aiInteractive?v="+this.md5
         vm.urlb="aiInteractive?v="+this.md5
      } else if (indexurl == 'workerorderindex') {
        window.location.href = "#/workerorderindex"
         vm.urlb="workerorderindex"
      }else {
         axios.get(this.basurl+'/api/visitor/im/sessionStatus?visitorMd5Code='+this.md5).then(function(response){
            console.log(response);
            let imStatus = '';
            if(response.data.code==1){
              imStatus=response.data.data.status;
            }
              console.log(imStatus)
                if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
                  vm.urlb="spirit"
                  window.location.href="#/spirit"

                  return
                } else if (imStatus === 'waiting') {
                  vm.urlb="imLineUp"
                  window.location.href="#/imLineUp"

                  return
                } else if (imStatus === 'chatting') {
                  vm.urlb="imSession"
                  window.location.href="#/imSession"

                  return
                } else {
                  if (imEntranceMode === 1) {
                      vm.urlb="imLineUp"
                     window.location.href="#/imLineUp"
                  } else if (imEntranceMode === 2) {
                      vm.urlb="imDirectory"
                      window.location.href="#/imDirectory"

                  }
               }

            console.log(vm.urlb)
          })
      }
    },
    // 视频处理
    videoBeforeload(file){
       var typeis=false;

       // var arr=file.name.split(".");
        var type=file.type
      //console.log(type)
      if( /^video\/.*$/.test(type)){
        typeis=true;
      }
      if(typeis==false){
         this.$message.error('文件格式不正确');
        return false
      }
      if(file.size / 1024 > (1024 * 500)){
        this.$message.error('文件大于500M');
        return false
      }
    },
    handleVideoRemove() {
      var vm=this;
       vm.$set(vm.picid,this.videobridge.id,true);
       //console.log( this.picid)
      //document.getElementById(this.videobridge.spanid+"a").style.display ="block";
      this.$set(this.fileVideoList, this.videobridge.id, [])
      if(this.videobridge.required==true){
        document.getElementById(this.videobridge.spanid).innerHTML="*必填项";
        this.submittable[this.videobridge.spanid]=false;
      }
      this.videobridge=" ";
      // this.btnclass=2;
    },
    handlePreview(response, file, fileList) {
     if(response.code==1){
      var vm=this;
       //document.getElementById(this.urlbridge.spanid+"a").style.display ="none";
        vm.$set(vm.picid,this.urlbridge.id,false);
       //this.picid[this.urlbridge.id]=false;
       console.log( this.picid)
       document.getElementById(this.urlbridge.spanid).innerHTML=" ";
       var is=this.datacommitis(this.urlbridge.id,response.data,this.urlbridge.spanid);
       if(is){
          this.submittable[this.urlbridge.spanid]=true;
          var obj={};
          obj.name=this.urlbridge.name;
          obj.id=this.urlbridge.id;
          obj.fieldId=this.urlbridge.id;
          obj.value=response.data;
          this.parmas.push(obj);
          var comit=true;
          var dataobj=this.submittable;
          console.log(dataobj)
          for(var key in dataobj){

             if(dataobj[key]==false){
              comit=false;
             }
          }
          if(comit==true){
            this.btnclass=1;
          }
       }

     }

    },
    handleVideoPreview(response, file, fileList) {
      console.log( this.picid[this.videobridge.id])
      console.log(response)
      if(response.code==1){
        var vm=this;
        //document.getElementById(this.videobridge.spanid+"a").style.display ="none";
        vm.$set( vm.picid,this.videobridge.id,false);
        //this.picid[this.videobridge.id]=false;
        document.getElementById(this.videobridge.spanid).innerHTML = " ";
        const is = this.datacommitis(this.videobridge.id,response.data,this.videobridge.spanid);
        let obj = {};
        obj.name = this.videobridge.name;
        obj.id = this.videobridge.id;
        obj.fieldId = this.videobridge.id;
        obj.type = response.data.type;
        obj.value = response.data;
        obj.url = response.data && response.data.split('?')? (response.data.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto'): '';
        this.$set(this.fileVideoList, this.videobridge.id, [obj])
        if(is) {
          this.submittable[this.videobridge.spanid]=true;
          this.parmas.push(obj);
          let comit=true;
          const dataobj=this.submittable;
          for(let key in dataobj) {

             if(dataobj[key]==false) {
              comit=false;
             }
          }
          if(comit==true){
            this.btnclass=1;
          }
       }
     }
    },
    //加入判断是否已经添加
    datacommitis(name,value,id){
      var vm=this;
      var is=true;
      //console.log(value)
        this.parmas.forEach( function(item, index) {
            if(item.fieldId==name){
              item.value=value;
              is=false;
              //vm.commitis=true;
              vm.submittable[id]=true;
              document.getElementById(id).innerHTML=" ";
            }
        });
        //console.log(this.parmas)
      return is;
    },
    //改变级联的值
    changedata(item,dat){
        //console.log(dat,44444444444)
        var vm=this;
        var changeis=false;
        if(item.parentId!=null && item.parentId!="" && item.parentId!=undefined && item.parentId!=" "){
          changeis=true;
        }
        if(changeis){
          if(vm.gamevalue[item.parentId]!=""){
            axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+item.id+'?visitorMd5Code='+this.md5+"&parentId="+vm.gamevalue[item.parentId]).then(function(response){
              if(response.data.code==1){
                  // console.log(vm.gamearea[obj.id])
                  //console.log(vm.gamearea)
                   var arrdata=response.data.data;
                   console.log(arrdata)
                   var arr=[];
                   var id="";
                  arrdata.forEach( function(element, index) {
                    var obj={};
                    obj.value=element.id;
                    obj.label=element.content;
                    arr.push(obj);
                    if(dat==element.content){
                      id=element.id;
                    }
                  });
                  //console.log(arr)
                  vm.gamearea[item.id]=[];
                  vm.$set( vm.gamearea,item.id,arr);
                  if(dat!=undefined){
                    vm.$set( vm.gamevalue,item.id,id);
                    vm.showdata.forEach( function(element, index) {
                      if(element.parentId==item.id){
                        if(element.enteredValue){
                          console.log(element.enteredValue)
                          vm.changedata(element,element.enteredValue)
                        }

                      }
                    });


                  }else{
                    vm.$set( vm.gamevalue,item.id,vm.gamevalue[item.id]);
                  }



              }

          })
        }
      }
    },
    //清空父节点
    clearparnt(item){
      var vm=this;
      //console.log(item.id);
      this.showdata.forEach( function(element, index) {
         if(element.parentId==item.id){
          //console.log(element);
          var arr=[];
            vm.$set( vm.gamearea,element.id,arr);
            vm.$set( vm.gamevalue,element.id,"");

         }
      });
    },
    //收集这个值
    datacommit(value,item){
      var typeid=item.typeId;
      var length=item.maxLength;
      var require=item.required;
      var name=item.name
      var spanid=item.spanid
      if(typeid==3){
        var now=new Date(value);
        var year = now.getFullYear();
        var month =(now.getMonth() + 1).toString();
        var day = (now.getDate()).toString();
        if (month.length == 1) {
            month = "0" + month;
        }
        if (day.length == 1) {
            day = "0" + day;
        }
        value = year + "-"+month +"-"+ day;
        //console.log(value)
      }
      if(typeid==4){
        //console.log(value,6667)
        var now=new Date(value);
        var hour = now.getHours();
        var minute =now.getMinutes();
        if (hour < 10) {
            hour = "0" + hour;
        }
        if (minute< 10) {
            minute = "0" + minute;
        }
        value = hour + ":"+minute ;
        //console.log(value)
      }
      //console.log(value+"/"+typeid);
      var valueis=false;
      var obj={};
      //单选和多选框
      if(typeid==1 || typeid==2){

        if(value.length>length || (value==undefined || value=='' || value.match(/^[ ]+$/)) ){
          valueis=false;
        }else{
           valueis=true;
        }

        if(require==false && (value==undefined || value=='' ||  value.match(/^[ ]+$/)) ){
          valueis=true;
        }
        if(valueis==false){
           var  message= '请输入长度为1~'+length+'字符';
            document.getElementById(spanid).innerHTML=message;
            this.submittable[spanid]=false;
        }else{
          var is=this.datacommitis(item.id,value,spanid)
          if(is){
             obj.fieldId=item.id;
             obj.name=name;
             obj.value=value;
             this.parmas.push(obj);
          }
          this.submittable[spanid]=true;
          document.getElementById(spanid).innerHTML=" ";
        }

      }
      //日期框
      if(typeid==3){

          if(value=="NaN-NaN-NaN"){
            valueis=false;
          }else{
            valueis=true;
          }
          if(require==false && value=="NaN-NaN-NaN"){
            valueis=true;
          }


          if(valueis==false){
            document.getElementById(spanid).innerHTML="*必填项";
            this.submittable[spanid]=false;
            valueis=false;
          }else{
            var is=this.datacommitis(item.id,value,spanid)
            if(is){
               obj.name=name;
               obj.value=value;
               obj.fieldId=item.id;
               this.parmas.push(obj);
               this.submittable[spanid]=true;
                document.getElementById(spanid).innerHTML=" ";
             }
             valueis=true;
          }

      }
      //时间框判断
      if(typeid==4){
          console.log(value,'笑嘻嘻222')
          if(value=="NaN:NaN"){
            value = ''
          }else{
            valueis=true;
          }
          if(require==false){
            valueis=true;
          }

        if(valueis==false ){
           document.getElementById(spanid).innerHTML="*必填项";
            this.submittable[spanid]=false;
        }else{
          var is=this.datacommitis(item.id,value,spanid)
          if(is){
             obj.name=name;
//             if(value=="NaN:NaN"){
//               obj.value = ''
//             }else {
//               obj.value=value;
//             }
            obj.value=value;
             obj.fieldId=item.id;
             this.parmas.push(obj)
             this.submittable[spanid]=true;
              document.getElementById(spanid).innerHTML=" ";
          }
        }
      }
      if(typeid==16){
        if(value=="NaN-NaN-NaN NaN:NaN") {
          valueis=false;
        }else{
          valueis=true;
        }
        if(require==false && value=="NaN-NaN-NaN NaN:NaN"){
          valueis=true;
        }

        if(valueis==false){
          document.getElementById(spanid).innerHTML="*必填项";
          this.submittable[spanid]=false;
          valueis=false;
        }else{
          var is=this.datacommitis(item.id,value,spanid)
          console.log(value, is, '=========222==========')
          if(is) {
            obj.name=name;
            obj.value=value?parseTime(value, '{y}-{m}-{d} {h}:{i}:{s}'):'';
            obj.id=item.id;
            obj.fieldId=item.id;
            this.parmas.push(obj);
            this.submittable[spanid]=true;
            document.getElementById(spanid).innerHTML="";
          }
          //  valueis=true;
        }
      }
      // 手机号验证
      if(typeid==5){
        var phoneis=/^1\d{10}$/.test(value)
          if(phoneis==false){
            valueis=false;
          }else{
            valueis=true;
          }
          if(require==false && (value==undefined || value=='')){
            valueis=true;
          }
          if(valueis==false){
             document.getElementById(spanid).innerHTML="请输入正确的手机号";
              this.submittable[spanid]=false;
          }else{
             var is=this.datacommitis(item.id,value,spanid)
             if(is){
                obj.name=name;
                obj.value=value;
                obj.fieldId=item.id;
                this.parmas.push(obj);
                this.submittable[spanid]=true;
                document.getElementById(spanid).innerHTML=" ";
              }
          }
      }
      // 数字文本框
      if(typeid==6){
        var numberis=/^\d+$/.test(value);
        if(numberis==false){
            valueis=false;
          }else{
           if(value.length>length){
              valueis=false;
            }else{
              valueis=true;
            }
          }
          if(require==false && (value==undefined || value=='')){
            valueis=true;
          }
           if(valueis==false){
             document.getElementById(spanid).innerHTML="请输入长度为1~"+length+"的数字";
              this.submittable[spanid]=false;
          }else{
             var is=this.datacommitis(item.id,value,spanid)
              if(is){
               obj.name=name;
               obj.value=value;
               obj.fieldId=item.id;
               this.parmas.push(obj);
                this.submittable[spanid]=true;
                document.getElementById(spanid).innerHTML=" ";
              }
          }

      }
      // 身份证文本框

      if(typeid==7){
        var idcardis=/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(value);
        if(idcardis==false){
          valueis=false;
        }else{
          valueis=true;
        }
        if(require==false && (value==undefined || value=='')){
          valueis=true;
        }
         if(valueis==false){
             document.getElementById(spanid).innerHTML="请输入正确的身份证号";
              this.submittable[spanid]=false;
          }else{
            var is=this.datacommitis(item.id,value,spanid)
             if(is){
               obj.name=name;
               obj.value=value;
               obj.fieldId=item.id;
               this.parmas.push(obj);
               this.submittable[spanid]=true;
                document.getElementById(spanid).innerHTML=" ";
             }
          }
      }

      //邮箱地址
      if(typeid==8){
        var emlis=/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value);
        if(emlis==false){
          valueis=false;
        }else{
          valueis=true;
        }
        if(require==false && (value==undefined || value=='')){
          if(value!=undefined){
            if( value.length>length){
              valueis=false;
            }else{
               valueis=true;
            }
          }
        }
        if(length!=null){
          var text="请输入"+length+"位以内正确的邮箱地址"
        }else{
          var text="请输入正确的邮箱地址"
        }
         if(valueis==false){
             document.getElementById(spanid).innerHTML=text;
              this.submittable[spanid]=false;
          }else{
                var is=this.datacommitis(item.id,value,spanid)
              if(is){
                 obj.name=name;
                 obj.value=value;
                 obj.fieldId=item.id;
                 this.parmas.push(obj);
                 this.submittable[spanid]=true;
                document.getElementById(spanid).innerHTML=" ";
              }
          }
      }
      //文件上传
      if(typeid==9){
        this.urlbridge=item;
        this.fileList2[item.name]=[];
        console.log(this.fileList2[item.name])
      }
      if (typeid==15) {
        this.videobridge = item;
      }
      //下拉框
      if(typeid==12){
        var vname="";
        this.gamearea[item.id].forEach( function(element, index) {
          if(element.value==value){
            vname=element.label
          }
        });
        value=vname;
        if(value!=undefined && value!=''){
           valueis=true;
        }else{
          valueis=false;
        }

        if(require==false && value==""){
          valueis=true;
        }
        if(valueis==false){
             document.getElementById(spanid).innerHTML="*必填项";
              this.submittable[spanid]=false;
          }else{
                this.clearparnt(item);
                //console.log(this.parmas)
                var is=this.datacommitis(item.id,value,spanid)
              if(is){
                 obj.name=name;
                 obj.value=value;
                 obj.fieldId=item.id;
                 this.parmas.push(obj);
                 this.submittable[spanid]=true;
                document.getElementById(spanid).innerHTML=" ";
              }
          }



      }
      //单选框
      if(typeid==13){
          //console.log(value)
          if(value!=undefined && value!=''){
            valueis=true;
          }else{
            valueis=false;
          }
          if(require==false && value==""){
          valueis=true;
        }
       if(valueis==false){
         document.getElementById(spanid).innerHTML="*必填项";
              this.submittable[spanid]=false;
        }else{
          var is=this.datacommitis(item.id,value,spanid)
          if(is){
             obj.name=name;
             obj.value=value;
             obj.fieldId=item.id;
            this.parmas.push(obj);
            this.submittable[spanid]=true;
          }
       }


      }
      //多选框
      if(typeid==14){
        //console.log(value)
        if(value.length>0){
          valueis=true;
        }else{
          valueis=false;
        }
        if(require==false && value.length==0){
          valueis=true;
        }
        if(valueis==false){
             document.getElementById(spanid).innerHTML="*必填项";
              this.submittable[spanid]=false;
          }else{
                var is=this.datacommitis(item.id,value,spanid)
              if(is){
                 obj.name=name;
                 obj.value=value;
                 obj.fieldId=item.id;
                 this.parmas.push(obj);
                 this.submittable[spanid]=true;
                document.getElementById(spanid).innerHTML=" ";
              }
          }

      }

       var comit=true;
      var dataobj=this.submittable
      console.log(typeid, dataobj, 'iiiooooiii')
      for(var key in dataobj){

         if(dataobj[key]==false){
          comit=false;
         }
      }
      if(comit==true){
        this.btnclass=1;
      }

      // if(valueis==false){

      //   this.commitis=false;
      // }else{
      //   this.commitis=true;
      // }
      //console.log(this.commitis)
    },
    heightlight(index) {
      var is=this.hobbys[index].is;
      if(is){
        this.hobbys[index].is=false;
      }else{
        this.hobbys[index].is=true;
      }
    },
     beforeload(file){
       console.log(file);
       var typeis=false;
         var type=file.type
       //console.log(type)
       if( /(gif|jpg|jpeg|bmp|png)$/.test(type)){
          typeis=true;
       }

      if(typeis==false){

       this.$message.error('文件格式不正确');
        return false
      }
      if(file.size / 1024 > (1024 * 9)){
        this.$message.error('文件大于9M');
        return false
      }
    },
    handleRemove() {
      var vm=this;

      // if(this.urlbridge==""){
      //   this.urlbridge=obj;
      // }
       vm.$set( vm.picid,this.urlbridge.id,true);
       console.log( this.picid)
      //document.getElementById(this.urlbridge.spanid+"a").style.display ="block";
      if(this.urlbridge.required==true){
        document.getElementById(this.urlbridge.spanid).innerHTML="*必填项";
        this.submittable[this.urlbridge.spanid]=false;
      }
      this.urlbridge=" ";
    },
    commit(){
      var vm=this;
      var comit=true;
      var dataobj=this.submittable
      for(var key in dataobj){

         if(dataobj[key]==false){
          comit=false;
         }
      }
      console.log(dataobj, 'iiioo11ooiii')
      this.parmas.forEach( function(element, index) {
          if(typeof(element.value)=="object"){
            var str=element.value.join(",");
            element.value=str;
          }
        });
      console.log(this.parmas,'zhongre')
     if(comit==true && this.href=="butianinfor"){
      var arr=[];
      var l=this.parmas.length;
      //console.log(this.paixu);
      //console.log(this.parmas)
       console.log(this.paixu,'草草哒')
        this.paixu.forEach( function(element, index) {
            var haveis=false;
            for(var i=0;i<l;i++){
              if(vm.parmas[i].fieldId==element.id){
                var obj={};
                obj.fieldId=vm.parmas[i].fieldId;
                obj.name=vm.parmas[i].name;
                obj.value=vm.parmas[i].value;
                haveis=true;
                arr.push(obj)
              }
            }
            if(haveis==false){
              let obj={};
              obj.fieldId=element.id;
              obj.name=element.name;
              obj.value=element.enteredValue;
              arr.push(obj)
            }

        });
        console.log(arr, '提交的东西')
         var obje=JSON.parse(sessionStorage.getItem('butianinfor'));
        axios.post(this.basurl+'/api/visitor/wo/updateOrder/'+obje.orderid+'/'+obje.fromid+'/'+obje.processInstanceId+'?visitorMd5Code='+this.md5,arr).then(function(response){
        //   //console.log(response)
              if(response.data.code==1){

                if(response.data.message=="OK"){
                  vm.successis=true;
                  vm.contentis=false;
                  var tme=setInterval(function () {
                  vm.jishi=vm.jishi-1;
                  if(vm.jishi==0){
                    //跳转分类
                    var indexurl=sessionStorage.getItem("indexUrl");
                    var imEntranceMode=sessionStorage.getItem("imEntranceMode")
                      // if (indexurl == 'workerorderindex') {
                  //   //alert(1)
                  //   vm.urlb="workerorderindex"
                  //   window.location.href = "#/workerorderindex"
                  // }
                    if (indexurl) {
                      vm.urlb= indexurl
                      vm.$router.replace({path: indexurl, query: {v: vm.md5}});
                    } else {
                     axios.get(vm.basurl+'/api/visitor/im/sessionStatus?visitorMd5Code='+vm.md5).then(function(response){
                        console.log(response);
                        let imStatus = '';
                        if(response.data.code==1){
                          imStatus=response.data.data.status;
                        }
                          console.log(imStatus)
                            if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
                              vm.urlb="spirit"
                              //window.location.href="#/spirit"
                              vm.$router.replace({path: 'spirit'});
                              return
                            } else if (imStatus === 'waiting') {
                              vm.urlb="imLineUp"
                              //window.location.href="#/imLineUp"
                              vm.$router.replace({path: 'imLineUp'});
                              return
                            } else if (imStatus === 'chatting') {
                              vm.urlb="imSession"
                              //window.location.href="#/imSession"
                              vm.$router.replace({path: 'imSession'});
                              return
                            } else {
                              if (imEntranceMode === 1) {
                                  vm.urlb="imLineUp"
                                 //window.location.href="#/imLineUp"
                                 vm.$router.replace({path: 'imLineUp'});
                              } else if (imEntranceMode === 2) {
                                  vm.urlb="imDirectory"
                                  //window.location.href="#/imDirectory"
                                  vm.$router.replace({path: 'imDirectory'});

                              }
                           }

            console.log(vm.urlb)
          })
      }

                    clearInterval(tme)
                  }
                 },1000)
                }else{
                  vm.erroris=true;
                  vm.contentis=false;
                  var tme=setInterval(function () {
                  vm.jishi=vm.jishi-1;
                  if(vm.jishi==0){
                    console.log(7667676767)
                     var indexurl=sessionStorage.getItem("indexUrl");
                    var imEntranceMode=sessionStorage.getItem("imEntranceMode")
                    console.log(indexurl)
                    if (indexurl == 'workerorderindex') {
                      //alert(1)
                      vm.urlb="workerorderindex"
                      window.location.href = "#/workerorderindex"
                    }else {
                       axios.get(vm.basurl+'/api/visitor/im/sessionStatus?visitorMd5Code='+vm.md5).then(function(response){
                          console.log(response);
                          let imStatus = '';
                          if(response.data.code==1){
                            imStatus=response.data.data.status;
                          }
                            console.log(imStatus)
                              if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
                                vm.urlb="spirit"
                                window.location.href="#/spirit"

                                return
                              } else if (imStatus === 'waiting') {
                                vm.urlb="imLineUp"
                                window.location.href="#/imLineUp"

                                return
                              } else if (imStatus === 'chatting') {
                                vm.urlb="imSession"
                                window.location.href="#/imSession"

                                return
                              } else {
                                if (imEntranceMode === 1) {
                                    vm.urlb="imLineUp"
                                   window.location.href="#/imLineUp"
                                } else if (imEntranceMode === 2) {
                                    vm.urlb="imDirectory"
                                    window.location.href="#/imDirectory"

                                }
                             }

                          console.log(vm.urlb)
                        })
                    }
                    clearInterval(tme)
                  }
                 },1000)
                };
              }else if(response.data.code == 400) {
                vm.erroris=true;
                vm.contentis=false;
                var tme=setInterval(function () {
                  vm.jishi = vm.jishi-1;
                  if(vm.jishi==0){
                    window.location.href="#/myorder"
                    clearInterval(tme)
                  }
                },1000)
              }
            });
      }else{
          this.$message({
          message: '数据填写错误',
          type: 'warning'
         });

       }

    },
    //
    butianinfor(){
       var vm=this;
      var obj=JSON.parse(sessionStorage.getItem('butianinfor'));
      axios.get(this.basurl+'/api/visitor/wo/processInstanceFields/'+obj.processInstanceId+'?visitorMd5Code='+this.md5).then(function(response){
        if(response.data.code=1){
          vm.show(response.data,2)
        };
      })
      console.log(obj)
    },
    //展示数据
    show(data,inde){
      var arrda = data.data;
      var vm=this;
      console.log(arrda,'数据')
      arrda.forEach( function(item, index) {
        vm.paixu.push(item)
        item.spanid='ziduan'+index;
        if(item.typeId==9 || item.typeId==15){
          vm.$set(vm.picid,item.id,true);
          console.log(vm.picid)
        }
        if(inde==1){
          if(item.required==false) {
            vm.submittable[item.spanid]=true;
          }else{
            vm.submittable[item.spanid]=false;
          }
        }
        if(inde==2){
          if(item.required==false) {
            vm.submittable[item.spanid]=true;
          } else {
            if (item.defaultContent || item.enteredValue) {
              vm.submittable[item.spanid]=true;
            } else {
              vm.submittable[item.spanid]=false;
            }
          }
        }
        vm.showdata.push(item);
        vm.datacollect(item);
      });
    },
    //判断是否授权
    showis(){
      var vm=this;
      axios.get(this.basurl+'/api/visitor/wo/formFields/'+this.href+'?visitorMd5Code='+this.md5).then(function(response){
        var da=response.data
        if(da.code==1){
          vm.loginis=false;
          vm.contentis=true;
          vm.show(da,1)
        }else if(da.code==401){
          vm.contentis=false;
          vm.loginis=true;
        }
     })
    },
     //手机验证
    verifyconfirm(){
      //console.log( this.verify)
      var vm=this;
      if( this.verify!=""&& this.btnis==true){
         axios.post(this.basurl+'/api/visitor/wo/msgCaptchaValid?visitorMd5Code='+this.md5+"&phoneNum="+this.phone+"&code="+this.verify).then(function(response){
            if(response.data.code==1){
              vm.showis();
              vm.veris="";
            }else if(response.data.code==0){
             vm.veris="验证码已过期请重新获取"
            }else if(response.data.code==4032){
              vm.$message.error('获取验证码过于频繁')
            }else{

               vm.veris="验证码填写错误"
            }
         })
      }else{
        vm.veris="请获取验证码"
      }

    },
    verifygo(){
      var vm =this;
       if(this.phone==''){
        this.phoneis="手机号不能为空"
      }
      if(this.phoneis!="手机号格式错误" &&  this.phoneis!="手机号不能为空"){
         axios.get(this.basurl+'/api/visitor/wo/msgCaptcha?visitorMd5Code='+this.md5+"&phoneNum="+this.phone).then(function(response){
          //console.log(response)
          this.btnis=true;
            if(response.data.code==1){
                 vm.verifyis=false;
                 var timer = setInterval(function () {
                    vm.timesecond= vm.timesecond-1;
                    if( vm.timesecond==0){
                      clearInterval(timer);
                      vm.verifyis=true;
                    }
                 },1000)
            }else if(response.data.code==4032){
               vm.$message.error('验证码获取过于频繁');
            }else if(response.data.code==4504){
              vm.$message.error('验证码已过期请重新获取');
            }
         })

      }
    },
    phonego(){
      var phonenumis=/^1\d{10}$/.test(this.phone);
      //console.log(phonenumis)
      if(phonenumis==false){
        this.phoneis="手机号格式错误"
      }else{
        this.phoneis="";
      }
    },
    // 设置相关的数据值，并且有值的时候更新一下提示语
    setMapData(data, key, value, dataObj){
      this.$set(data, key, value);
      console.log('=========================================')
      console.log(data, key, value, dataObj)
      if (value !=null && value != undefined && value != '') {
        setTimeout(()=>{
          this.datacommit(value, dataObj)
        },0)
      }
    },
    datacollect(obj){
      var vm=this;
      //console.log(obj)
      if(obj.parentId==null){
          obj.parentId=" ";
        }
      if(obj.typeId==12){
         if(obj.parentId==" "){
            axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
              if(response.data.code==1){
                  console.log(obj,'xxx')
                  // console.log(vm.gamearea[obj.id])
                  // console.log(vm.gamearea)
                   var arrdata=response.data.data;
                   var arr=[];
                   var id="";
                  arrdata.forEach( function(element, index) {
                    var obj1={};
                    obj1.value=element.id;
                    obj1.label=element.content;
                    arr.push(obj1)
                    if(element.content==obj.enteredValue){
                      id=element.id;
                    }
                  });
                  //console.log(arr)
                  vm.$set( vm.gamearea,obj.id,arr);
                  vm.$set( vm.gamevalue,obj.id,id);
                   //alert(1)
                  vm.showdata.forEach( function(element, index) {
                    if(element.parentId==obj.id){
                      console.log(element)
                      vm.changedata(element,element.enteredValue);
                    }
                  });

              }else{

                console.log('拉取数据失败')
              }
          })
         }
        //else{
        //    var arr=[];
        //    vm.$set( vm.gamearea,obj.id,arr);
        //    vm.$set( vm.gamevalue,obj.id,"");
        //    vm.changedata(obj,"first")

        // }

      }else if(obj.typeId==1){
            axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
                if(response.data.code==1){

                    //  var arrdata=response.data.data;
                    //  console.log(arrdata)
                    //  var arr=[];
                    // arrdata.forEach( function(element, index) {
                    //   var obj={};
                    //   arr.push(obj)
                    // });
                    //console.log(arr)
                    //console.log(vm.gamevalue)
                    vm.$set( vm.dns,obj.id,obj.enteredValue);
                }else{
                  console.log('拉取数据失败')
                }
          })
      }else if(obj.typeId==2){
          vm.$set( vm.explain,obj.id,obj.enteredValue);

      }else if(obj.typeId==3){
        vm.$set( vm.datetime,obj.id,obj.enteredValue);
      }else if (obj.typeId==4) {
          console.log(obj,'钱')
        if(obj.enteredValue != ''){
          var arr=obj.enteredValue.split(":")
          var time=new Date(10,1,30,Number(arr[0]),Number(arr[1]),0)
          vm.$set( vm.hourtime,obj.id,time);
        }else {
          vm.$set( vm.hourtime,obj.id,'');
        }
      }else if (obj.typeId==5) {

        vm.$set( vm.phonenumver,obj.id,obj.enteredValue);
      }else if (obj.typeId==6) {

        vm.$set( vm.number,obj.id,obj.enteredValue);
      }else if (obj.typeId==7) {

        vm.$set( vm.idcard,obj.id,obj.enteredValue);
      }else if (obj.typeId==8) {

        vm.$set( vm.email,obj.id,obj.enteredValue);
      }else if(obj.typeId==14){
            axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
                if(response.data.code==1){

                    var arrdata=response.data.data;
                    //返回数据有问题
                     //console.log(obj.defaultContent);


                     if(obj.enteredValue.split(",").length>1){
                       var arrd=obj.enteredValue.split(",")
                       //eval(obj.defaultContent);
                     }else{
                      var arrd=[];
                      arrd.push(obj.enteredValue.split(",")[0])
                     }
                      console.log(arrd);
                     var arr=[];
                     var arr1=[];
                     var defaultContentid=true;
                     var l=arrdata.length;
                     arrd.forEach( function(element, index) {

                        var addis = false;
                        for(var i=0;i<l;i++){
                          if(arrdata[i].content==element){
                            addis=true;
                          }
                        }
                        if(addis==false){
                          defaultContentid=false;
                        }
                          arr1.push(element);

                      });
                     if(defaultContentid==false){
                        arr1=[];
                     }
                      arrdata.forEach( function(element, index) {
                        arr.push(element.content);
                      });
                      vm.$set( vm. checkedCities1,obj.id,arr1);
                      vm.$set( vm. cities,obj.id,arr);
                }else{
                  console.log('拉取数据失败')
                }
          })
      }else if (obj.typeId==13) {
//          var mo=obj.defaultContent;
          axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
                if(response.data.code==1){

                    var arrdata=response.data.data;
                    //console.log(arrdata);
                    var arr=[];
//                    var defaultContentid=false;
                    arrdata.forEach( function(element, index) {
                      var obj={};
                      obj.value=element.content;
                      obj.label=element.content;
                      arr.push(obj);
                      //console.log(element.defaultContent,66)
//                      if(mo==element.content){
//                        defaultContentid=true;
//                      }
                    });
                   // console.log(obj.defaultContent)
//                    if(defaultContentid==false){
//                      obj.enteredValue="";
//                    }
                     vm.$set( vm.sexlabel,obj.id,arr);
                     vm.$set( vm.sex,obj.id,obj.enteredValue);
                }else{
                  console.log('拉取数据失败')
                }
          })
      }
      else if (obj.typeId==9 || obj.typeId==15) {
        var arr=[];
        this.action=this.basurl+'/api/visitor/wo/fileUpload?visitorMd5Code='+this.md5;
        var arro={};

          this.picid[obj.id]=true;
          if (obj.typeId==15) {
            arro.url = obj.enteredValue && obj.enteredValue.split('?')? (obj.enteredValue.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto'): ''
            arro.name='file.mp4';
          } else {
            arro.url=obj.enteredValue;
            arro.name='file.jpg';
          }

        if(arro.url!=""){
          arr.push(arro)
        }
        if (obj.typeId==15) {
          vm.$set(vm.fileVideoList, obj.id, arr);
        } else {
          vm.$set(vm.fileList2, obj.name, arr);
        }
        // console.log(vm.fileVideoList, 999)
        // vm.$set( vm.fileList2,obj.name,arr);
        //console.log(vm.fileList2)
      } else if(obj.typeId==16) {
        let timeVal = ''
        if (/^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          timeVal = (obj.enteredValue || obj.defaultContent)
        }
        vm.setMapData(vm.datetimes, obj.id, timeVal, obj)
      }


    }
  }
}
</script>

<style scoped>
 .top .title_img{
  display: inline-block;
  float: left;
  height: 35px;
  width: auto;
  margin: 5px 0 5px 20px;
}
.top .title_2{
  color:#fff;
  display: inline-block;
  float: left;
  margin-left:20px;
}
.top .title_2 span{
  font-size: 16px
}
  .verbtn{
    display: block;
    width: 100px;
    margin: 0 auto;
    margin-top: 20px;
  }
  .verifybtn{
    display: inline-block;
    width: 120px;
    height: 36px;
    background:#36c6d3;
    border-radius: 4px;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    margin-left: 10px;
    cursor: pointer;
  }
  .mat{
    margin-top: 8px;
  }
  .login{
    width: 370px;
    margin: 0 auto;
  }

  .login p{
    margin-top: 100px;
    font-size: 12px;
    color: #999999;
    margin-bottom: 4px;
    margin-left: 64px;
  }
  .login div p{
    color: #ed6b75;
    margin-top: 4px;
    height: 14px;
  }
  .login div span{
    font-size: 14px;
    color: #666666;
    margin-right: 18px;

  }
  .login div .verifybtn{
      color: #ffffff;
      margin-right: 0;
  }
  .login div .phonenumber{
    width: 300px;
  }
  .login div .verify{
    width: 165px;
  }
  .success{
    width: 640px;
    text-align: center;
    margin-top: 100px;
  }
  .success h4{
    font-size: 16px;
    color: #319bf3;
    margin-top: 14px;
  }
  .success .error{
    color: #ff864a;
  }
  .success p{
    margin-top: 24px;
    color: #999;
  }

  .btn{
    clear: both;
    text-align: center;
    height: 40px;
    width: 100%;
    padding-top: 40px;
    margin-bottom: 40px;
  }
  .btn .color{
    width: 100px;
    height: 40px;
  }
  .content{
    width: 560px;
    position: relative;
    margin:0 auto;
    margin-top: 30px;
    clear: both;
  }
  .content .error1{
    color: #ed6b75;
    position: absolute;
    top: 10px;
    font-size: 12px;
    left:440px;
  }
 .workerorderindex{
  background: #f8f8f8;
  width: 100%;
  height: 100%;
 }
 .color{
  background: #009688;
 }
 .top{
   height: 46px;
   width: 100%;
 }
 .logo{
  margin-left: 20px;
  width: 140px;
  height: 34px;
  margin-top: 6px;
 }
 .top img,.top span{
  display: block;
  float: right;
  color: #fff;
  font-size:14px;
  cursor: pointer;
 }
 .top span{
  line-height: 46px;
  margin-left: 10px;
 }
 .kefu{
  position: absolute;
  right: 86px;
  margin-top: 11px;
 }
 .nav{
  width: 560px;
  margin:0 auto;
  height: 45px;
  border-bottom: 1px solid #000;
  font-size: 14px;
 }
 .nav span{
  line-height: 45px;
  color: #5987c2;
   font-weight:bold;
  text-decoration: underline;
 }
  .nav .btna{
    display: block;
    color: white;
    font-size: 14px;
    width: 70px;
    height: 24px;
    float: right;
    border-radius: 4px;
    text-align:center;
    line-height: 24px;
    margin-top: 11px;
  }
  .nav .navbread{
    text-decoration: none;
    color: #000;
    font-weight:bold;
  }
  .label{
    margin-left: 20px;
    display: inline-block;
    width: 100px;
    font-size: 14px;
    text-align: right;
    margin-right: 10px;
    display: block;
    float: left;
  }
  .wid{
    width: 300px;
  }
  .dns{
    margin-top:10px;
  }
  .dns .wid{
    margin-left: -5px;
  }
  .explain{
    margin-top:10px;
  }
  .explain   .label{
    display: block;
    float: left
  }

  .sex{
    margin-top: 20px;
  }
  .hobbys{
    margin-top: 20px;
  }
  .hobbys .label{
    display: block;
    float: left;
    margin-top: 4px;
  }
  .hobby{
    margin-left: 10px;
    display: block;
    float: left;
    width: 50px;
    height: 24px;
    border:1px solid #ccc;
    border-radius: 10px;
    background: #fff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    overflow: hidden;
  }
  .back{
    border:1px solid #1f9cf8;
    color: #1f9cf8;
  }
  .hobbys p{
    clear: both;
    font-size: 14px;
    color: #999999;
    margin-left: 140px;
    padding-top: 10px;
  }
  .picture{
    margin-top: 20px;
  }
  .pictureclass{
    font-size: 14px;
    color: #999999;
  }
  .upload-demo{
    margin-left: 140px;
    width: 320px
  }
  .city{
    margin-top: 20px;
  }
  .radio{
    width: 300px;
  }
  .cityclass{
    float: left;
    width: 300px;
  }
  .time{
    width: 300px;
    float: left;
  }
  .date{
    clear: both;
    margin-top: 20px;
  }
  .date .label{
    display: block;
    float: left;
    margin-top: 8px;
  }
  .dns .label{
    display: block;
    float: left;
    margin-top: 6px;
    margin-right: 16px;
  }
  .download{
    width: 640px;
    height: 570px;
    position: fixed;
    background:rgba(0,0,0,0.5);
    color: white;
   left:50%;
   top:50%;
   margin:-264px 0 0 -320px;
   z-index: 1000;
  }
  .download img{
    display: block;
    width: 47px;
    height: 47px;
    margin: 0 auto;
    margin-top: 180px;
  }
  .download  p{
    text-align: center;
    margin-top: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/workorder/butianinfor.vue?7cc2c895